// External libraries
import React from 'react';
import styled from 'styled-components';

// Zocdoc libraries
import { navy } from '@zocdoc/branding/colors';

// Icon code
import { Icon } from './_base';

const CloseSVG = styled(Icon).attrs({ viewBox: '0 0 40 40' })``;

const Close = ({ color = navy, ...props }) => (
    <CloseSVG data-test="icon-close" {...props}>
        <polygon
            fill={color}
            points="40,4 36,0 20,16 4,0 0,4 16,20 0,36 4,40 20,24 36,40 40,36 24,20"
        />
    </CloseSVG>
);

export { Close as default, Close };
